/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Category_Code_TakenInputs */

const vi_product_category_code_taken = /** @type {(inputs: Product_Category_Code_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã danh mục này đã có — chọn mã khác.`)
};

/**

* @param {Product_Category_Code_TakenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_category_code_taken = /** @type {((inputs?: Product_Category_Code_TakenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Category_Code_TakenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_category_code_taken(inputs)
});